<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useGtm } from '@/hooks/useGtm'
export default defineComponent({
  name: 'FramePatternChildRender',
  props: {
    item: {
      type: Object,
      default: () => ({} as AnyObject),
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selected'],
  setup(props, { emit }) {
    const { pushGtm } = useGtm()
    const refFramePattern = ref()

    const selected = (item) => {
      // TODO: skip if not active
      if (!props.isActive)
        return
      emit('selected', item)
      pushGtm(refFramePattern.value)
    }

    return {
      refFramePattern,
      selected,
    }
  },
})
</script>

<template>
  <div
    ref="refFramePattern"
    v-ripple
    class="relative-position cursor-pointer q-ma-sm shadow-1"
    :class="[
      isCurrent && 'border',
      {
        'cursor-pointer': isActive,
        'disabled-default cursor-not-allowed': !isActive,
      },
    ]"
    :glasson-click="item.gtmKey"
    style="width: 160px"
    @click="selected(item)"
  >
    <q-badge
      v-if="!isActive"
      class="absolute-top-left text-body2 text-red text-weight-medium"
      style="z-index: 10; border-radius: 0 0 4px 0"
      color="grey-6"
    >
      改装中
    </q-badge>
    <q-img
      style="max-height: 80px"
      :src="item.url"
      :alt="item.key"
      loading="lazy"
      fit="fill"
      fetchpriority="high"
    >
      <div
        v-if="isCurrent"
        class="absolute-top-right bg-transparent"
        style="padding: 2px 4px"
      >
        <q-avatar
          class="shadow-3"
          color="secondary"
          text-color="white"
          size="sm"
        >
          <q-icon name="checked" size="16px" />
        </q-avatar>
      </div>
    </q-img>
    <div
      class="text-caption text-center q-my-xs" :class="[
        isCurrent
          ? 'text-weight-bold text-primary'
          : 'text-weight-medium text-dark',
      ]"
    >
      {{ item.name }}
    </div>
  </div>
</template>
